import {Outlet, Navigate} from "react-router-dom";
import {useContext} from "react";
import AuthContext from "../context/AuthContext";


function PrivateRoute() {
    // const { status, data } = useAuth()
    // console.log('In private route', data)
    const {accessToken} = useContext(AuthContext)
    let isAuthenticated = accessToken ? true: false
    // let auth = true
    // let auth = {'token': true}

    return (
        <>
            {isAuthenticated? <Outlet/> : <Navigate to='/login'/>}
        </>
    );
}

export default PrivateRoute;
